export * from "./phone-number.directive";
export * from "./input-name.directive";



// WEBPACK FOOTER //
// ./src/app/shared/directives/index.ts